module.exports = __webpack_public_path__ + "img/trolley-ecg.f9613f92.png";